<div class="media-player-component">
    <div class="media-player" [ngClass]="{'minimal': minimal, 'dark-theme': theme === 'dark'}"
        [class.disabled]="disabled">
        <!-- Full Media Player -->
        <div class="loading-indicator" *ngIf="isLoading">Loading audio...</div> <!-- Loading indicator -->
        <div class="controls d-flex justify-content-center align-items-center" *ngIf="!minimal">

            <!-- First line: Progress and Duration -->
            <div class="progress-container">
                <input type="range" [value]="currentTime" [max]="duration || 0" (input)="seek($event)"
                    class="progress-bar" [disabled]="tracks.length === 0" />
                <span class="duration">{{ getTimeDisplay() }}</span>
            </div>

            <!-- Second line: Controls -->
            <div class="control-row">
                <button (click)="playPrevious()" class="control-btn prev" title="Previous Track"
                    [disabled]="!hasPrevious() || tracks.length === 0" style="display: none;">
                    <span class="material-symbols-outlined">
                        keyboard_double_arrow_left
                    </span>
                </button>
                <button (click)="skipBackward()" class="control-btn skip-back" title="Skip Backward 5 Seconds"
                    [disabled]="tracks.length === 0">
                    <span class="material-symbols-outlined">
                        replay_5
                    </span>
                </button>
                <button (click)="replay()" class="control-btn replay" [disabled]="tracks.length === 0" title="Replay">
                    <span class="material-symbols-outlined">
                        replay
                    </span>
                </button>
                <button (click)="togglePlayPause()" class="control-btn play" [title]="isPlaying? 'Pause': 'Play'"
                    [disabled]="tracks.length === 0">
                    <span class="material-symbols-outlined">
                        {{ isPlaying ? 'pause' : 'play_arrow' }}
                    </span>
                </button>

                <button (click)="playNext()" class="control-btn next" [disabled]="!hasNext() || tracks.length === 0"
                    title="Next Track" style="display: none;">
                    <span class="material-symbols-outlined">
                        keyboard_double_arrow_right
                    </span>
                </button>
                <button (click)="skipForward()" class="control-btn skip-forward" title="Skip Forward 5 Seconds"
                    [disabled]="tracks.length === 0">
                    <span class="material-symbols-outlined">
                        forward_5
                    </span>
                </button>
                <div class="speed-control">
                    <span class="material-symbols-outlined" title="PlayBack Speed">avg_pace</span>
                    <input type="range" min="0.5" max="2" step="0.1" [value]="getPlaybackRate()"
                        (input)="setSpeed($event)" class="speed-bar" [disabled]="tracks.length === 0" />
                    <span class="speed-tooltip">{{ getPlaybackRate().toFixed(1) }}x</span>
                </div>
                <div class="volume-control">
                    <span class="material-symbols-outlined" title="Volume">volume_up</span>
                    <input type="range" min="0" max="1" step="0.1" [value]="getVolume()" (input)="setVolume($event)"
                        class="volume-bar" [disabled]="tracks.length === 0" />
                    <span class="volume-tooltip">{{ (getVolume() * 100).toFixed(0) }}%</span>
                </div>
            </div>
        </div>

        <!-- Minimal Media Player -->
        <div class="minimal-controls d-flex justify-content-center align-items-center" *ngIf="minimal">
            <button (click)="stop()" class="control-btn stop" [disabled]="tracks.length === 0 || !isPlaying">
                <span class="material-symbols-outlined">stop</span>
            </button>
            <button (click)="togglePlayPause()" class="control-btn play"
                [disabled]="tracks.length === 0 || (isPlaying && !hasNext() && !hasPrevious())">
                <span class="material-symbols-outlined">{{ isPlaying ? 'pause' : 'play_arrow' }}</span>
            </button>
            <div class="progress-container">
                <input type="range" class="progress-bar" [value]="currentTime" [max]="duration"
                    [disabled]="tracks.length === 0 || !isFiniteDuration()" (input)="seek($event)" />
            </div>
        </div>
        <audio #audioPlayer (timeupdate)="onTimeUpdate()" preload="metadata"></audio>
    </div>
</div>